import { useLauncherStrategyProvider } from 'lib/launchStrategies/LauncherStrategyProvider';
import { updateHash, resolveDeepLinkDetails } from 'lib/launchStrategies/helpers';
import { useInitProvider } from 'providers/InitProvider';
import { useEffect } from 'react';
import { IApp } from 'types';
import { RQX_HASH_VALUE } from './config';

const SAME_TAB = 'sametab';

const findIn = (list: IApp[]) => (id: string) =>
  list.find((app) => app.code === id);

export function useInitialApp() {
  const initData = useInitProvider();
  const { launchApplication } = useLauncherStrategyProvider();
  const { dump } = initData;
  const { current, available } = dump?.workspace;

  useEffect(() => {
    if (initData.dump) {
      const hash = window.location.hash;
      const hashValue = hash.substring(1);
      console.log(`useInitialApp hashValue="${hashValue}" href="${window.location.href}"`)

      // use for deeplinking in hosted apps
      window.localStorage.setItem(RQX_HASH_VALUE, hashValue);

      // TEST ONLY
      const rqxHashValue = window.localStorage.getItem(RQX_HASH_VALUE);
      console.log(`In useEffect, local storage ${RQX_HASH_VALUE}="${rqxHashValue}"`);

      // open requested or default app on mount
      const {
        apps,
        shell: { defaultApplicationId },
      } = initData.dump;

      const byId = findIn(apps);

      const appCodeToken = hashValue.split('/')[0];
      console.log(`useInitialApp looking for hashValue="${hashValue}" appCodeToken="${appCodeToken}"`)
      const deepLinkDetails = resolveDeepLinkDetails(hashValue);
      console.log(`useInitialApp deepLinkDetails="${deepLinkDetails}"`);
      const appData = byId(appCodeToken) || byId(defaultApplicationId);
      if (appData) {
        console.log(`useInitialApp hash="${hash}" appData="${appData.code}"`)
        /**
         * IMPORTANTE: l'applicazione iniziale, che sia quella di default o quella letta dall'hash, si deve aprire in un iframe della stessa pagina
         */
        const updatedData: IApp = {
          ...appData,
          target: SAME_TAB,
          deepLinkDetails: deepLinkDetails,
        };
        if (current || (available && available.length <= 1)) {
          launchApplication(updatedData);
        } else {
          updateHash('Workspace', 'workspace');
        }
      } else {
        console.error(
          `Application not found. Tried "${hashValue}" and "${defaultApplicationId}"`,
        );
      }
    }
  }, [initData.dump, launchApplication]);
}
